import { callAct, isOk } from './apiConfig';

/*
 * notifications — real in-app notifications for the business owner (התראות), backed by the
 * notifications table + the notificationsList / notificationMarkRead / notificationsMarkAllRead
 * acts. All scoped server-side to the session business. Notifications are generated as a
 * best-effort side effect of booking events (new/manual booking, cancel/no-show) and, when
 * this list is fetched, reminders for reservations starting within ~2h (in-app, no cron —
 * they materialize while the owner has the app open).
 *
 * A single item: { ID, type, title, body, refID, isRead(0|1), createdAt }.
 *   type ∈ booking_new | booking_manual | booking_cancel | booking_noshow | booking_reminder
 */

// Fetch notifications + unread count. Returns { items: [], unread: 0 } on error (never throws).
export async function listNotifications() {
    try {
        const envelope = await callAct('notificationsList', {});
        if (isOk(envelope) && envelope.data) {
            return {
                items: Array.isArray(envelope.data.items) ? envelope.data.items : [],
                unread: Number(envelope.data.unread) || 0,
            };
        }
    } catch (e) { /* act not available */ }
    return { items: [], unread: 0 };
}

// Mark ONE notification read. Best-effort; returns true on success.
export async function markRead(id) {
    try {
        const envelope = await callAct('notificationMarkRead', { ID: id });
        return isOk(envelope);
    } catch (e) { return false; }
}

// Mark ALL of the business's notifications read (clears the bell badge).
export async function markAllRead() {
    try {
        const envelope = await callAct('notificationsMarkAllRead', {});
        return isOk(envelope);
    } catch (e) { return false; }
}

export default { listNotifications, markRead, markAllRead };
